import React from 'react';
import './Payments.css';
import './Overview.css';

const Payments = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <h1>Payments</h1>
          <div className="page-meta">Reference: SSI/ENG/2026/TWX-001</div>
        </div>
      </div>

      <div className="invoice-card">
        <div className="invoice-header">
          <div className="invoice-title">Invoice SSI/INV/2026/TWX-001</div>
          <div className="status-badge paid">PAID</div>
        </div>
        
        <div className="invoice-row">
          <span>Advisory & Filing Fee — Advance (50%)</span>
          <span className="amount">₹4,950.00</span>
        </div>
        <div className="invoice-row">
          <span>GST @ 18%</span>
          <span className="amount">₹891.00</span>
        </div>
        
        <div className="invoice-divider"></div>
        
        <div className="invoice-row total">
          <span>Total Paid</span>
          <span className="amount">₹5,841.00</span>
        </div>
      </div>

      <div className="invoice-card">
        <div className="invoice-header">
          <div className="invoice-title">Invoice SSI/INV/2026/TWX-002</div>
          <div className="status-badge due">DUE ON SUBMISSION</div>
        </div>
        
        <div className="invoice-row">
          <span>Advisory & Filing Fee — Balance (50%)</span>
          <span className="amount">₹4,950.00</span>
        </div>
        <div className="invoice-row">
          <span>GST @ 18%</span>
          <span className="amount">₹891.00</span>
        </div>
        
        <div className="invoice-divider"></div>
        
        <div className="invoice-row total">
          <span>Total Due</span>
          <span className="amount">₹5,841.00</span>
        </div>

        <button className="pay-btn">Pay now</button>
      </div>
    </div>
  );
};

export default Payments;
